// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CostCenterDto, UserDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CostCenterApiClient extends BaseCRUDApiClient<CostCenterDto> {
  baseUrl = this.config.apiEndpoint + '/cost-center';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  getCoordinator(id: string) {
    return this.http.get<UserDto>(this.baseUrl + `/${id}/coordinator`);
  }

  getCoordinators(id: string) {
    return this.http.get<UserDto[]>(this.baseUrl + `/${id}/coordinators`);
  }
}
